// extracted by mini-css-extract-plugin
module.exports = {"wrap":"e_Rv","pin":"e_Sv","tip":"e_Tv","wrapOpen":"e_Uv"};